import { clx } from '../lib/utils';

interface IWelcomeBalloonsProps {
  className?: string;
}

export const WelcomeBalloons = ({ className = '' }: IWelcomeBalloonsProps) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 253 337"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clx('h-auto max-h-full w-auto max-w-full', className)}
      role="img"
      aria-label="Welcome balloons illustration"
      preserveAspectRatio="xMidYMid meet"
    >
      <g filter="url(#filter0_dii_525_1522)">
        <path d="M77 166L88.2583 186.25H65.7417L77 166Z" fill="url(#paint0_linear_525_1522)" />
      </g>
      <g filter="url(#filter1_dii_525_1522)">
        <ellipse cx="77.5" cy="114" rx="48.5" ry="58" fill="url(#paint1_linear_525_1522)" />
      </g>
      <g filter="url(#filter2_dii_525_1522)">
        <path
          d="M75.6958 187C76.1358 187 76.5824 188.1 76.6958 190.317C76.9219 194.74 70.8291 196.987 66.8191 200.983C65.1255 202.671 65.4758 205.433 65.3624 207.65C65.1363 212.073 70.7891 214.32 73.6858 217.653C76.5645 220.966 76.8024 226.307 75.3724 230.653C73.6305 235.948 66.3758 239.2 65.1424 243.65C64.8427 244.732 65.0291 245.867 65.5791 246.543C68.0918 249.635 72.1224 251.653 75.4625 255.097C78.7281 258.463 78.1358 263.867 78.0324 268.207C77.926 272.677 71.9358 275.427 68.4858 278.433C67.0424 280.093 66.1424 282.1 65.9191 284.317C65.9158 285.433 66.1358 286.533 67.6958 288.333"
          stroke="url(#paint2_linear_525_1522)"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#filter3_dii_525_1522)">
        <path
          d="M139.5 201L153.789 215.25H125.211L139.5 201Z"
          fill="url(#paint3_linear_525_1522)"
        />
      </g>
      <g filter="url(#filter4_dii_525_1522)">
        <ellipse cx="140.5" cy="164" rx="43.5" ry="43" fill="url(#paint4_linear_525_1522)" />
      </g>
      <g filter="url(#filter5_dii_525_1522)">
        <path
          d="M141.033 216C141.253 217.767 141.7 225.28 139.82 230.763C139.065 232.966 137.927 235.1 137.26 237.647C135.706 243.582 140.353 247.76 142.25 252.093C143.295 254.481 143.033 257.54 142.593 260.533C141.736 266.369 136.38 269.093 133.377 273.98C129.964 279.534 133.687 287.533 136.027 292.973C135.927 302.433 134.813 305.767 134.48 308.423C134.367 309.98 134.367 311.96 134.367 314"
          stroke="url(#paint5_linear_525_1522)"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#filter6_dii_525_1522)">
        <path d="M196 97L202.928 118H189.072L196 97Z" fill="url(#paint6_linear_525_1522)" />
      </g>
      <g filter="url(#filter7_dii_525_1522)">
        <ellipse cx="196" cy="57.5" rx="35" ry="46.5" fill="url(#paint7_linear_525_1522)" />
      </g>
      <g filter="url(#filter8_dii_525_1522)">
        <path
          d="M194.722 118C194.848 119.009 195.605 121.541 195.676 125.724C195.742 129.686 192.697 133.213 192.122 136.829C191.433 141.165 193.823 143.751 195.415 145.846C197.153 148.135 198.902 152.362 199.669 155.68C200.298 158.4 197.905 161.514 196.25 163.739C194.522 166.064 194.722 175.158 195.733 181.501C196.261 184.818 197.889 187.782 198.023 195.442C198.09 199.344 195.491 201.487 193.966 204.345C193.584 205.047 193.207 205.675 193.013 206.815C192.818 207.956 192.818 209.589 192.818 211.271"
          stroke="url(#paint8_linear_525_1522)"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
      <defs>
        {/* Simplified drop shadow filter for better performance */}
        <filter
          id="filter0_dii_525_1522"
          x="58.675"
          y="162.467"
          width="36.6499"
          height="34.3833"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dx="0" dy="3.5" stdDeviation="3.5" floodColor="rgba(45, 25, 44, 0.25)" />
        </filter>
        <filter
          id="filter1_dii_525_1522"
          x="0.6"
          y="41.8"
          width="153.8"
          height="172.8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dx="0" dy="14" stdDeviation="14" floodColor="rgba(49, 24, 46, 0.44)" />
        </filter>
        <filter
          id="filter2_dii_525_1522"
          x="48.7374"
          y="178.368"
          width="45.6654"
          height="133.858"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dx="0" dy="7.6" stdDeviation="7.6" floodColor="rgba(45, 25, 44, 0.25)" />
        </filter>
        <filter
          id="filter3_dii_525_1522"
          x="118.277"
          y="197.533"
          width="42.4458"
          height="28.1167"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dx="0" dy="3.5" stdDeviation="3.5" floodColor="rgba(20, 42, 45, 0.25)" />
        </filter>
        <filter
          id="filter4_dii_525_1522"
          x="73.9333"
          y="109.467"
          width="133.133"
          height="132.133"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dx="0" dy="11.5" stdDeviation="11.5" floodColor="rgba(19, 40, 44, 0.46)" />
        </filter>
        <filter
          id="filter5_dii_525_1522"
          x="116.469"
          y="207.735"
          width="42.0406"
          height="129.061"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dx="0" dy="7.3" stdDeviation="7.3" floodColor="rgba(20, 42, 45, 0.25)" />
        </filter>
        <filter
          id="filter6_dii_525_1522"
          x="183.205"
          y="94.0667"
          width="25.5898"
          height="32.7333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dx="0" dy="3" stdDeviation="3" floodColor="rgba(41, 41, 16, 0.25)" />
        </filter>
        <filter
          id="filter7_dii_525_1522"
          x="139.267"
          y="0.133333"
          width="113.467"
          height="136.467"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dx="0" dy="11" stdDeviation="11" floodColor="rgba(42, 42, 17, 0.46)" />
        </filter>
        <filter
          id="filter8_dii_525_1522"
          x="177.528"
          y="110.264"
          width="36.7164"
          height="122.214"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dx="0" dy="6.7" stdDeviation="6.7" floodColor="rgba(41, 41, 16, 0.25)" />
        </filter>
        <linearGradient
          id="paint0_linear_525_1522"
          x1="77"
          y1="166"
          x2="77"
          y2="193"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD8BF9" />
          <stop offset="1" stopColor="#BE68BA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_525_1522"
          x1="77.5"
          y1="56"
          x2="77.5"
          y2="172"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF92FF" />
          <stop offset="1" stopColor="#B158A8" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_525_1522"
          x1="71.5701"
          y1="187"
          x2="71.5701"
          y2="288.333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD8BF9" />
          <stop offset="1" stopColor="#BE68BA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_525_1522"
          x1="139.5"
          y1="201"
          x2="139.5"
          y2="220"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70ECFB" />
          <stop offset="1" stopColor="#54B1BC" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_525_1522"
          x1="140.5"
          y1="121"
          x2="140.5"
          y2="207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73F3FF" />
          <stop offset="1" stopColor="#448F9E" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_525_1522"
          x1="137.49"
          y1="216"
          x2="137.49"
          y2="314"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70ECFB" />
          <stop offset="1" stopColor="#54B1BC" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_525_1522"
          x1="196"
          y1="97"
          x2="196"
          y2="125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6E65B" />
          <stop offset="1" stopColor="#ACAC44" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_525_1522"
          x1="196"
          y1="11"
          x2="196"
          y2="104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFF66" />
          <stop offset="1" stopColor="#98983C" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_525_1522"
          x1="195.886"
          y1="118"
          x2="195.886"
          y2="211.271"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E6E65B" />
          <stop offset="1" stopColor="#ACAC44" />
        </linearGradient>
      </defs>
    </svg>
  );
};
